import { render } from "./Section3Brilliance.vue?vue&type=template&id=67317165&scoped=true"
const script = {}

import "./Section3Brilliance.vue?vue&type=style&index=0&id=67317165&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67317165"]])

export default __exports__